/**
 * Fills recently-viewed sections from localStorage handles via /products/{handle}.js
 */
(function () {
  var STORAGE_KEY = 'shaaranga_recently_viewed_v1';

  function escapeHtml(str) {
    if (str == null) return '';
    var d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  function imageSrc(img) {
    if (!img) return '';
    if (typeof img === 'string') return img;
    return img.src || '';
  }

  function formatMoney(cents, currency, locale) {
    var n = Number(cents);
    if (Number.isNaN(n)) n = 0;
    try {
      return new Intl.NumberFormat(locale || undefined, {
        style: 'currency',
        currency: currency || 'USD',
      }).format(n / 100);
    } catch (e) {
      return (n / 100).toFixed(2);
    }
  }

  function buildCardMarkup(p, opts) {
    var origin = window.location.origin;
    var path = p.url || '/products/' + p.handle;
    var url = path.indexOf('http') === 0 ? path : origin + path;
    var img1 = imageSrc(p.featured_image) || (p.images && p.images[0] ? imageSrc(p.images[0]) : '');
    var img2 =
      opts.showSecondary && p.images && p.images[1] ? imageSrc(p.images[1]) : '';
    var v0 = p.variants && p.variants[0];
    var variantId = v0 && v0.id ? v0.id : '';
    var priceRupee = (Number(p.price) || 0) / 100;
    var soldOut = p.available === false;
    var compareAt =
      p.compare_at_price != null && Number(p.compare_at_price) > Number(p.price);
    var ratioPercent = opts.imageRatio === 'portrait' ? '125%' : '100%';

    var badge = '';
    if (soldOut) {
      badge =
        '<span class="badge badge--bottom-left color-' +
        escapeHtml(opts.soldOutBadgeScheme) +
        '">' +
        escapeHtml(opts.soldOutLabel) +
        '</span>';
    } else if (compareAt) {
      var disc = Math.round(
        ((Number(p.compare_at_price) - Number(p.price)) * 100) / Number(p.compare_at_price)
      );
      badge =
        '<span class="badge badge--bottom-left color-' +
        escapeHtml(opts.saleBadgeScheme) +
        '">' +
        disc +
        '% Off</span>';
    }

    var secondImg = '';
    if (img2) {
      secondImg =
        '<img src="' +
        escapeHtml(img2) +
        '" alt="" class="motion-reduce" loading="lazy" width="533" height="533">';
    }

    // Wishlist button intentionally not rendered here: the XB Wishlist (Swym)
    // app injects its own button into .card-wrapper elements. This fallback
    // card is a .card-wrapper, so the app handles the wishlist button.
    var wishlist = '';

    var priceHtml = '';
    if (p.template_suffix !== 'price-on-request') {
      var regular = formatMoney(p.price, opts.currency, opts.locale);
      if (compareAt) {
        var compare = formatMoney(p.compare_at_price, opts.currency, opts.locale);
        priceHtml =
          '<div class="price price--on-sale"><div class="price__container">' +
          '<div class="price__regular">' +
          '<span class="visually-hidden visually-hidden--inline">' +
          escapeHtml(opts.priceSaleLabel) +
          '</span>' +
          '<span class="price-item price-item--sale price-item--last">' +
          regular +
          '</span></div>' +
          '<div class="price__compare">' +
          '<span class="visually-hidden visually-hidden--inline">' +
          escapeHtml(opts.priceRegularLabel) +
          '</span>' +
          '<s class="price-item price-item--regular">' +
          compare +
          '</s></div></div></div>';
      } else {
        priceHtml =
          '<div class="price"><div class="price__container"><div class="price__regular">' +
          '<span class="price-item price-item--regular">' +
          regular +
          '</span></div></div></div>';
      }
    }

    var mediaBlock = '';
    if (img1) {
      mediaBlock =
        '<div class="card__media">' +
        '<div class="media media--transparent media--hover-effect">' +
        '<img src="' +
        escapeHtml(img1) +
        '" alt="' +
        escapeHtml(p.title) +
        '" class="motion-reduce" loading="lazy" width="533" height="667">' +
        secondImg +
        '</div>' +
        '</div>';
    }

    return (
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      wishlist +
      '<a href="' +
      escapeHtml(url) +
      '">' +
      '<div class="card card--' +
      escapeHtml(opts.cardStyle) +
      ' card--media">' +
      '<div class="card__inner color-' +
      escapeHtml(opts.cardColorScheme) +
      ' gradient ratio" style="--ratio-percent: ' +
      ratioPercent +
      ';">' +
      mediaBlock +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h5">' +
      '<span class="full-unstyled-link">' +
      escapeHtml(p.title) +
      '</span></h3></div>' +
      '<div class="card__badge ' +
      escapeHtml(opts.badgePosition) +
      '">' +
      badge +
      '</div></div></div>' +
      '<div class="card__content">' +
      '<div class="card__information">' +
      '<h3 class="card__heading h5">' +
      '<span class="full-unstyled-link">' +
      escapeHtml(p.title) +
      '</span></h3>' +
      '<div class="card-information">' +
      priceHtml +
      '</div></div></div></div></a></div>'
    );
  }

  function initRoot(root) {
    var max = parseInt(root.getAttribute('data-max-products') || '12', 10);
    var currency = root.getAttribute('data-currency') || 'USD';
    var locale = root.getAttribute('data-locale') || '';
    var showSecondary = root.getAttribute('data-show-secondary') === 'true';
    var wishlistEnabled = root.getAttribute('data-wishlist') === 'true';
    var imageRatio = root.getAttribute('data-image-ratio') || 'portrait';
    var cardStyle = root.getAttribute('data-card-style') || 'standard';
    var cardColorScheme = root.getAttribute('data-card-color-scheme') || 'scheme-1';
    var soldOutBadgeScheme = root.getAttribute('data-sold-out-badge-scheme') || 'scheme-5';
    var saleBadgeScheme = root.getAttribute('data-sale-badge-scheme') || 'scheme-4';
    var soldOutLabel = root.getAttribute('data-sold-out-label') || 'Sold out';
    var priceSaleLabel = root.getAttribute('data-price-sale-label') || 'Sale price';
    var priceRegularLabel = root.getAttribute('data-price-regular-label') || 'Regular price';
    var badgePosition = root.getAttribute('data-badge-position') || 'top right';
    var wrapper = root.querySelector('[data-recently-viewed-slides]');
    var mount = root.querySelector('[data-recently-viewed-mount]');
    var swiperEl = root.querySelector('[data-recently-viewed-swiper]');
    var prevEl = root.querySelector('[data-rv-prev]');
    var nextEl = root.querySelector('[data-rv-next]');

    if (!wrapper || !mount) return;

    var handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {}
    if (!Array.isArray(handles)) handles = [];
    handles = handles.slice(0, max);

    if (handles.length === 0) {
      mount.setAttribute('hidden', '');
      return;
    }

    var rootPath = '/';
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      rootPath = window.Shopify.routes.root;
      if (rootPath.slice(-1) !== '/') rootPath += '/';
    }

    // Inject the finished card HTML strings into slides and (re)init Swiper.
    function mountCards(cardHtmls) {
      if (!cardHtmls.length) {
        mount.setAttribute('hidden', '');
        return;
      }
      mount.removeAttribute('hidden');
      wrapper.innerHTML = cardHtmls
        .map(function (html, i) {
          return (
            '<div class="swiper-slide" data-rv-index="' +
            i +
            '" role="group" aria-roledescription="slide">' +
            html +
            '</div>'
          );
        })
        .join('');

      if (typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent('recently-viewed:rendered', { detail: { root: root } }));
      }

      if (typeof Swiper !== 'undefined' && swiperEl) {
        var n = cardHtmls.length;
        var swiperOpts = {
          slidesPerView: 4,
          spaceBetween: 25,
          loop: n > 4,
          observer: true,
          observeParents: true,
          watchOverflow: true,
          breakpoints: {
            1024: { slidesPerView: 4, spaceBetween: 25, loop: n > 4 },
            768: { slidesPerView: 3, spaceBetween: 20, loop: n > 3 },
            480: { slidesPerView: 2, spaceBetween: 16, loop: n > 2 },
            0: { slidesPerView: 1.5, spaceBetween: 12, loop: n > 1 },
          },
        };
        if (prevEl && nextEl) {
          swiperOpts.navigation = { nextEl: nextEl, prevEl: prevEl };
        }
        new Swiper(swiperEl, swiperOpts);
      }
    }

    // Fallback: build cards client-side from product JSON (no quick-add). Used
    // only if the Section Rendering request below is unavailable, so the
    // section never disappears.
    function jsonFallback() {
      var opts = {
        showSecondary: showSecondary,
        wishlistEnabled: wishlistEnabled,
        imageRatio: imageRatio,
        cardStyle: cardStyle,
        cardColorScheme: cardColorScheme,
        soldOutBadgeScheme: soldOutBadgeScheme,
        saleBadgeScheme: saleBadgeScheme,
        soldOutLabel: soldOutLabel,
        priceSaleLabel: priceSaleLabel,
        priceRegularLabel: priceRegularLabel,
        currency: currency,
        locale: locale,
        badgePosition: badgePosition,
      };
      Promise.all(
        handles.map(function (handle) {
          return fetch(rootPath + 'products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin',
          })
            .then(function (res) {
              return res.ok ? res.json() : null;
            })
            .catch(function () {
              return null;
            });
        })
      )
        .then(function (products) {
          mountCards(
            products.filter(Boolean).map(function (p) {
              return buildCardMarkup(p, opts);
            })
          );
        })
        .catch(function () {
          mount.setAttribute('hidden', '');
        });
    }

    // Primary: render the real card-product snippet per product via the Section
    // Rendering API, so Recently viewed cards match the rest of the site exactly
    // (quick-add / Add to cart on hover, wishlist heart, badges, sale price…).
    Promise.all(
      handles.map(function (handle) {
        return fetch(
          rootPath + 'products/' + encodeURIComponent(handle) + '?section_id=card-product-ajax',
          { credentials: 'same-origin' }
        )
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .catch(function () {
            return '';
          });
      })
    )
      .then(function (htmls) {
        var cards = htmls.filter(function (h) {
          return h && h.indexOf('product-card-wrapper') !== -1;
        });
        if (cards.length) {
          mountCards(cards);
        } else {
          jsonFallback();
        }
      })
      .catch(jsonFallback);
  }

  function boot() {
    document.querySelectorAll('[data-recently-viewed-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
